<div class="main placement-detail">
    <div class="title-btn">
        <div class="main-title"></div>
    </div>

    <div class="info-tile-container">
        <app-info-tile
            [infoName]="'Cycle Age'"
            [infoValue]="summaryDetails.cycleAge + ' Days'"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Bird Count'"
            [infoValue]="summaryDetails.bridCount"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Avg Weight'"
            [infoValue]="(summaryDetails.avgWeight | number: '1.2-2') + 'g'"
        ></app-info-tile>
        <!-- <app-info-tile
            [infoName]="'Density'"
            [infoValue]="(summaryDetails.density | number: '1.2-2') + 'm²'"
        ></app-info-tile> -->
    </div>
    <ng-container
        [ngComponentOutlet]="cycleInsights"
        [ngComponentOutletInputs]="{
            placement: placement,
            placementId: placementId,
            medications: medications,
            mortalities: mortalities,
            vaccinations: vaccines,
            averageWeights: averageWeights,
            performance: performance,
            onOpenMedicationForm: openMedicationPopupHandler,
            onOpenMortalityForm: openMortalityPopupHandler,
            onOpenVaccinationForm: openVaccinationPopupHandler,
            onOpenBodyWeightForm: openBodyWeightPopupHandler
        }"
    ></ng-container>

    <!-- Medication Program Dialog -->
    <p-dialog
        [(visible)]="showMedicationPopup"
        modal="true"
        focusOnShow="false"
        [style]="{width: '1100px'}"
        [closable]="false"
        [baseZIndex]="200000"
        [appendTo]="'body'"
    >
        <div
            class="text-left close-popup-pdialog"
            (click)="closeMedicationPopup()"
        >
            <span class="fas fa-chevron-left"></span> Back
        </div>
        <ng-template pTemplate="content">
            <app-active-medication-program
                [placementId]="placementId"
                (close)="closeMedicationPopup()"
                (dataSaved)="onMedicationDataSaved()"
            ></app-active-medication-program>
        </ng-template>
    </p-dialog>

    <!-- Mortality Dialog -->
    <p-dialog
        [(visible)]="showMortalityPopup"
        modal="true"
        focusOnShow="false"
        [style]="{width: '800px'}"
        [closable]="false"
        [baseZIndex]="200000"
        [appendTo]="'body'"
    >
        <div
            class="text-left close-popup-pdialog"
            (click)="closeMortalityPopup()"
        >
            <span class="fas fa-chevron-left"></span> Back
        </div>
        <ng-template pTemplate="content">
            <app-active-mortality
                [placementId]="placementId"
                (close)="closeMortalityPopup()"
                (dataSaved)="onMortalityDataSaved()"
            ></app-active-mortality>
        </ng-template>
    </p-dialog>

    <!-- Vaccination Dialog -->
    <p-dialog
        [(visible)]="showVaccinationPopup"
        modal="true"
        focusOnShow="false"
        [style]="{width: '800px'}"
        [closable]="false"
        [baseZIndex]="200000"
        [appendTo]="'body'"
    >
        <div
            class="text-left close-popup-pdialog"
            (click)="closeVaccinationPopup()"
        >
            <span class="fas fa-chevron-left"></span> Back
        </div>
        <ng-template pTemplate="content">
            <app-active-vaccines-program
                [placementId]="placementId"
                (close)="closeVaccinationPopup()"
                (dataSaved)="onVaccinationDataSaved()"
            ></app-active-vaccines-program>
        </ng-template>
    </p-dialog>

    <!-- Body Weight Dialog -->
    <p-dialog
        [(visible)]="showBodyWeightPopup"
        modal="true"
        focusOnShow="false"
        [style]="{width: '800px'}"
        [closable]="false"
        [baseZIndex]="200000"
        [appendTo]="'body'"
    >
        <div
            class="text-left close-popup-pdialog"
            (click)="closeBodyWeightPopup()"
        >
            <span class="fas fa-chevron-left"></span> Back
        </div>
        <ng-template pTemplate="content">
            <app-average-body-weight
                [placementId]="placementId"
                (closeDialog)="closeBodyWeightPopup()"
                (dataSaved)="onBodyWeightDataSaved()"
            ></app-average-body-weight>
        </ng-template>
    </p-dialog>
</div>
